import React from 'react';
import { Link } from 'react-router-dom';
import { GraduationCap, Award, BookOpen, Mail, Phone } from 'lucide-react';
import { FACULTY } from '../data/mock';

export default function Faculty() {
  return (
    <div className="fade-in">
      <section className="coral-gradient text-white relative overflow-hidden">
        <div className="absolute inset-0 dotted-bg opacity-60" />
        <div className="relative max-w-7xl mx-auto px-5 sm:px-8 py-20 lg:py-28">
          <div className="text-white/90 text-xs font-semibold uppercase tracking-[0.18em]">Faculty & Founders</div>
          <h1 className="font-serif font-semibold text-5xl md:text-6xl mt-4 leading-[1.05] max-w-4xl">
            Mentors who shape <span className="gold-text italic">generations.</span>
          </h1>
          <p className="mt-6 text-white/90 text-lg max-w-2xl">
            Meet the dedicated faculty heads who lead RN Academy across Arts, Science and Foundation programs.
          </p>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-5 sm:px-8 py-20">
        <div className="grid md:grid-cols-3 gap-6">
          {FACULTY.map((f) => (
            <div key={f.name} className="bg-white rounded-3xl p-7 border border-orange-100 smooth card-hover">
              <div className="w-24 h-24 rounded-2xl coral-gradient text-white font-serif font-bold text-3xl flex items-center justify-center shadow-coral">
                {f.initials}
              </div>
              <h3 className="font-serif font-semibold text-2xl mt-5">{f.name}</h3>
              <div className="text-coral font-medium text-sm mt-1">{f.role}</div>
              <div className="flex items-center gap-2 text-stone-500 text-xs mt-2">
                <GraduationCap className="w-3.5 h-3.5" /> {f.qual}
              </div>
              <p className="text-stone-600 text-sm mt-4 leading-relaxed">{f.bio}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-[#fff1ea] rounded-3xl p-10 grid md:grid-cols-3 gap-8 items-center">
          <div className="md:col-span-2">
            <div className="text-coral text-xs font-semibold uppercase tracking-[0.18em]">Join the team</div>
            <h3 className="font-serif text-3xl font-semibold mt-2">Passionate educators are always welcome.</h3>
            <p className="text-stone-600 mt-3">If you are an experienced teacher in ICSE, CBSE or ISC subjects and would like to be part of RN Academy’s legacy, write to us.</p>
          </div>
          <div className="flex flex-col gap-3">
            <a href="mailto:contact@rnacademy.org" className="btn-primary smooth font-medium px-5 py-3 rounded-xl text-center inline-flex items-center justify-center gap-2">
              <Mail className="w-4 h-4" /> contact@rnacademy.org
            </a>
            <a href="tel:+919903248390" className="bg-white border border-orange-200 hover:bg-coral-light smooth font-medium px-5 py-3 rounded-xl text-center inline-flex items-center justify-center gap-2 text-stone-800">
              <Phone className="w-4 h-4 text-coral" /> 99032-48390
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
